<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="KONTNIPLAN.KONTO.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtKonto"
                formControlName="Konto"
                #focusElement
                [MaxLength]="8"
                [ngClass]="{'is-invalid': submitted && fc.Konto.invalid}"
                [Label]="'KONTNIPLAN.KONTO.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Konto.invalid">
                    <span *ngFor="let validation of errorMessages.Konto">
                      <span class="error-message" *ngIf="fc.Konto.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="KONTNIPLAN.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                [MaxLength]="100"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'KONTNIPLAN.NAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
            </div>
          </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="KONTNIPLAN.NAZIVEN.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNazivEn"
                formControlName="NazivEn"
                [MaxLength]="100"
                [ngClass]="{'is-invalid': submitted && fc.NazivEn.invalid}"
                [Label]="'KONTNIPLAN.NAZIVEN.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.NazivEn.invalid">
                    <span *ngFor="let validation of errorMessages.NazivEn">
                      <span class="error-message" *ngIf="fc.NazivEn.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
            </div>
          </div>
          <div class="form-group row">
              <label class="col-form-label col-3"><span translate="KONTNIPLAN.IMAANA.SINGULAR"></span></label>
              <div class="col-md-9">
                      <input
                        style="width: 20px;"
                        type="checkbox"
                        class="form-control"
                        formControlName="ImaAna"
                        name="chkImaAna"
                      > 
              </div>
            </div>
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="KONTNIPLAN.VRSTAKONTNOGPLANAID.SINGULAR"></span></label> -->
              <div class="col-md-12">
                  <!-- <yt-fw-dropdown
                  [ModelName]="'vrstakontnogplana'"
                  [GetName]="'get'"
                  [ModelProperty]="'Naziv'"
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]='true'
                  [Required]='true'
                  [Disabled]='false'
                  formControlName="VrstaKontnogPlanaID"                   
                  name="cmbVrstaKontnogPlana"
                  [Type]="ID"
                  [ngClass]="{'is-invalid': submitted && fc.VrstaKontnogPlanaID.invalid}"
                  [Label]="'KONTNIPLAN.VRSTAKONTNOGPLANAID.SINGULAR'">
                </yt-fw-dropdown> -->
                <yt-dropdown-picklist
                    [ModelName]="'vrstakontnogplana'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="false"
                    formControlName="VrstaKontnogPlanaID"
                    [Label]="'KONTNIPLAN.VRSTAKONTNOGPLANAID.SINGULAR'"
                    >
              </yt-dropdown-picklist>
                <div class="form-error" *ngIf="submitted && fc.VrstaKontnogPlanaID.invalid">
                    <span *ngFor="let validation of errorMessages.VrstaKontnogPlanaID">
                      <span class="error-message" *ngIf="fc.VrstaKontnogPlanaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</form>